"use client";

import { motion } from "motion/react";

import { FloatingWrapper } from "./floating-images.wrapper";
import { FloatingElement } from "./floating-images.element";
import { useFloatingImages, UseFloatingImagesProps } from "./use-floating-images";

export type FloatingImagesProps = UseFloatingImagesProps;

export const FloatingImages = (props: FloatingImagesProps) => {
  const { images } = useFloatingImages(props);

  return (
    <FloatingWrapper sensitivity={-1} className="overflow-hidden z-2">
      {images.map((image) => (
        <FloatingElement
          key={image.id}
          depth={image.depth}
          className={image.wrapperClassName}
        >
          <motion.img
            initial={{ opacity: 0 }}
            src={image.src}
            className={image.className}
          />
        </FloatingElement>
      ))}
    </FloatingWrapper>
  );
};
